import L from 'leaflet';
import { includes, isEmpty } from 'lodash';
import turf from '@turf/turf';

const FEATURE_COLLECTION_TYPE = 'FeatureCollection';

/**
 * Draws the DTM bounding box on the leaflet map.
 *
 * @param {object} arg - The object argument.
 * @param {object} arg.aiInterestArea - The interest area for AI.
 * @param {?object} arg.aiInterestAreaLayer - The geoJSON layer where the interest area for AI is painted.
 * @param {object} arg.leafletMap - The leaflet map object.
 * @param {boolean} [arg.isUpdate=false] - Flag to determine if we are doing an update.
 * @param {boolean} [arg.isEntities=false] - Flag to determine if wich geometry we are editing.
 * @returns {object} The leaflet layer where the DTM bounding box is painted.
 */
const drawMapInterestArea = ({
  aiInterestArea,
  aiInterestAreaLayer,
  leafletMap,
  isUpdate = false,
  isEntities = false
}) => {
  let newAIInterestArea = '';
  const zIndex = 1000;
  if (!isUpdate) {
    leafletMap.createPane(`${zIndex}`);
    // eslint-disable-next-line no-param-reassign
    leafletMap.getPane(`${zIndex}`).style.zIndex = '650';

    newAIInterestArea = new L.FeatureGroup().addTo(leafletMap);
  } else {
    newAIInterestArea = aiInterestAreaLayer;
    // newAIInterestArea.clearLayers();
  }

  if (!isEmpty(aiInterestArea)) {
    let layerToAdd = L.geoJSON(aiInterestArea, {
      color: '#5cb85c',
      weight: 4,
      fill: false,
      pane: `${zIndex}`
    }).getLayers()[0];
    if (aiInterestArea.type === FEATURE_COLLECTION_TYPE) {
      if (isEntities)
        layerToAdd = L.geoJSON(aiInterestArea, {
          color: '#4A90E2',
          weight: 4,
          fill: false,
          pane: `${zIndex}`
        });
      else
        layerToAdd = L.geoJSON(aiInterestArea, {
          color: '#5cb85c',
          weight: 4,
          fill: false,
          pane: `${zIndex}`
        });
    }
    newAIInterestArea.addLayer(layerToAdd);
    const bbox = turf.bbox(aiInterestArea);
    if (!includes(bbox, Infinity))
      leafletMap.fitBounds([
        [bbox[1], bbox[0]],
        [bbox[3], bbox[2]]
      ]);

    const editedGeometryLayer = layerToAdd.toGeoJSON(15);
    if (editedGeometryLayer.geometry.type === 'Polygon') {
      const area = turf.area(editedGeometryLayer) / 10000;
      layerToAdd.bindPopup(`${Math.round((area + Number.EPSILON) * 100) / 100} ha`).openPopup();
    }
    if (editedGeometryLayer.geometry.type === 'LineString') {
      const distance = turf.length(editedGeometryLayer, { units: 'kilometers' });
      layerToAdd.bindPopup(`${Math.round((distance + Number.EPSILON) * 100) / 100} km`).openPopup();
    }
  }
  return newAIInterestArea;
};

export default drawMapInterestArea;
